<template>
  <section
    class="section-pay w-full max-w-[1600px] mx-auto px-140 flex justify-between min-h-607"
  >
    <div class="section-pay-left text-left w-full">
      <div class="flex justify-between w-full items-end">
        <div class="logo">
          <img src="@/assets/home_logo.png" alt="GeoswiftCARD" class="logo" />
        </div>
        <div class="footer-bottom w-500">
          <p class="mb-20">{{ $t('lang.footer3') }}</p>
          <div class="mb-20">
            <img src="@/assets/home_31.png" alt="phone" class="icon w-23 h-23" />
            <p>400-661-6888</p>
          </div>
          <div class="mb-20">
            <img src="@/assets/home_41.png" alt="email" class="icon w-23 h-18" />
            <p>service@georc.cn</p>
          </div>
        </div>
      </div>

      <div class="flex justify-between w-full items-end mt-100 pb-100 border-b border-[#dcdcdc]">
        <div class="footer-top">
          <div style="font-size: 32px; font-weight: 800;" class=" text-black mb-20">{{ $t('lang.footer1') }}</div>
          <el-button
            class="min-w-170 h-50 text-center"
            type="primary"
            style="background: #FF7800;border-radius: 5px 5px 5px 5px;border: 1px solid #FF7800;font-size:18px;padding: 0 20px;"
            @click="goRegister"
          >{{ $t('lang.footer2') }}</el-button>
        </div>

        <div class="flex  w-500">
          <div class="flex items-center justify-center mr-80">
            <img src="@/assets/home_34.png" alt="certification" class="icon w-53 h-35 mr-10" />
            <p style="text-align:center;">
              {{ $t('lang.footer4') }}
              <br />{{ $t('lang.footer5') }}
            </p>
          </div>
          <div class="flex items-center justify-center">
            <img src="@/assets/home_37.png" alt="certification" class="icon w-90 h-20 mr-10" />
            <p>{{ $t('lang.footer6') }}</p>
          </div>
        </div>
      </div>

      <div class="pt-50 pb-50 text-center text-[#707070] text-14 cursor-pointer" @click="goBeian">
        <p>{{ $t('lang.footer7') }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    goBeian() {
      window.open('https://beian.miit.gov.cn/');
    },
    goRegister() {
      window.open("https://vccmmr.geo.sh.cn/#/register");
    }
  }
}; 
</script>

<style scoped lang="less">
.logo {
  width: 280px;
  height: 50px;
  margin-bottom: 50px;
}
.footer-top {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  h2 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 20px;
    margin-top: 50px;
  }
  .register-btn {
    width: 100px;
    height: 30px;
    background-color: #FF7800;
    color: #fff;
    border-radius: 5px;
  }
}
.footer-bottom {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  margin-top: 100px;
  position: relative;
  top: 10px;
  p {
    font-size: 18px;
    font-weight: 600;
    // margin-bottom: 20px;
    color: #333;
  }
  div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
    p {
      font-size: 18px;
      font-weight: 400;
      color: #333;
      margin-left: 10px;
    }
    .icon {
      // width: 24px;
      // height: 24px;
      margin-right: 10px;
    }
  }
}
</style>